import { useDragScroll } from '@/hooks/useDragScroll';
import { Box, Stack, Typography } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContext } from '../..';
import './index.scss';

export const GameAgreement = () => {
    const { t } = useTranslation();
    const { ref } = useDragScroll();
    const { setExtraCloseHandler } = useContext(DialogContext);

    useEffect(() => {
        setExtraCloseHandler(() => () => {});
    }, []);

    return (
        <Box
            ref={ref}
            className="game-agreement"
            sx={{
                '&::-webkit-scrollbar': {
                    display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
                },
                '&-ms-overflow-style': {
                    display: 'none', // Hide the scrollbar for IE
                },
            }}
        >
            <Stack className="content" spacing={3}>
                <Typography>{t('agreement.0')}</Typography>

                <Box sx={{ direction: 'column' }}>
                    <Typography color={'#BF9A5D'}>
                        {t('agreement.1')}
                    </Typography>
                    <Typography>{t('agreement.2')}</Typography>
                </Box>
                <Typography>{t('agreement.3')}</Typography>
                <Typography>{t('agreement.4')}</Typography>
                <Typography>{t('agreement.5')}</Typography>
                <Typography>{t('agreement.6')}</Typography>
                <Typography>{t('agreement.7')}</Typography>

                <Typography paddingLeft={'1rem'}>{t('agreement.8')}</Typography>
                <Typography paddingLeft={'1rem'}>{t('agreement.9')}</Typography>
                <Typography paddingLeft={'1rem'}>
                    {t('agreement.10')}
                </Typography>

                <Box sx={{ direction: 'column' }}>
                    <Typography color={'#BF9A5D'}>
                        {t('agreement.11')}
                    </Typography>
                    <Typography>{t('agreement.12')}</Typography>
                </Box>
                <Typography>{t('agreement.13')}</Typography>
                <Typography>{t('agreement.14')}</Typography>
                <Typography>{t('agreement.15')}</Typography>
                <Typography>{t('agreement.16')}</Typography>
                <Typography>{t('agreement.17')}</Typography>
            </Stack>
        </Box>
    );
};
